module.exports = __webpack_public_path__ + "static/media/map-marker.f27cbec7.png";